module.exports = __webpack_public_path__ + "static/media/emission.220d2813.svg";